<template>
  <div>
    <div style="display: flex;align-items: center;">
      <div class="title" style="flex: 1;">
        <h3 v-if="!this.$route.params.subscription">{{$t('dashboard.payments_history.title')}}</h3>
        <h3 v-if="this.$route.params.subscription">{{$t('dashboard.payments_history.title_subscription')}}</h3>
      </div>
      <div v-if="this.$route.params.subscription">
        <router-link
          class="see-all-payments-button"
          :to="{name: 'payments'}">
          {{ $t('dashboard.payments_history.see_all_payments') }}
        </router-link>
      </div>
    </div>
    <ResourceTable
      :resource="PaymentsTable.resource"
      :params="PaymentsTable.options"
      :perPage="per_page"
    >
      <template slot="header">
        <th>
          {{$t('dashboard.payments_history.table.date')}}
        </th>
        <th>
          {{$t('dashboard.payments_history.table.description')}}
        </th>
        <th>
          {{$t('dashboard.payments_history.table.card')}}
        </th>
        <th class="mobile-hide">
          {{$t('dashboard.payments_history.table.status')}}
        </th>
        <th class="mobile-hide">
          {{$t('dashboard.payments_history.table.amount')}}
        </th>
      </template>
      <template slot-scope="{element}">
        <td style="text-align: center;">
          {{$d(new Date(element.created_at), 'short')}}
        </td>
        <td>
          {{element.subscription_plan.data.description}}
        </td>
        <td style="text-align: center;">
          {{element.user_credit_card.data.last_4_digits ? 'XXXX-'+element.user_credit_card.data.last_4_digits : '-'}}
        </td>
        <td class="mobile-hide" style="text-align: center;">
          {{$t(`payment_status.${element.status}`)}}
        </td>
        <td class="mobile-hide" style="text-align: right;">
          ${{element.amount}}
        </td>
      </template>
      <template slot="responsive_card_{element}" slot-scope="{element}">
        <div class="card">
          <div style="display: flex;margin:1rem 0;align-items: center;">
            <div style="flex: 1">{{$d(new Date(element.created_at), 'short')}}</div>
            <div style="border-radius:0.5rem;padding: 0.3rem 0.5rem;font-weight: bold;font-size: 0.9rem;" :class="element.status">{{$t(`payment_status.${element.status}`)}}</div>
          </div>
          <div>{{element.subscription_plan.data.description}}</div>
          <div style="display: flex;margin:1rem 0;align-items: center;">
            <div style="flex: 1;">{{element.user_credit_card.data.last_4_digits ? 'XXXX-'+element.user_credit_card.data.last_4_digits : '-'}} {{element.user_credit_card.data.type}}</div>
            <div class="amount">${{element.amount}}</div>
          </div>
        </div>
      </template>
      <template slot="empty">
        {{$t('noRecords')}}
      </template>
    </ResourceTable>
  </div>
</template>
<script>
import ResourceTable from "../components/ResourceTable"
import resources from "../resources";

export default {
  name: 'PaymentHistoryTable',
  components: {ResourceTable},
  computed: {
    PaymentsTable(){
      let data = {
        resource: resources.payments,
        options: {
          order_by: [['created_at', 'desc']],
          user_id: this.$auth.user().id
        }
      };

      if(this.$route.params.subscription) {
        data.options.subscription_id = this.$route.params.subscription;
      }
      return data;
    },
  },
  data() {
    return {
      per_page: process.env.VUE_APP_PER_PAGE
    }
  }
}
</script>
<style scoped lang="scss">
@import '../styles/variables';
@import '../styles/classes';

.see-all-payments-button {  
  &:hover {
    font-weight: bold;
  }
}

.card {
  border-radius: 1rem;
  margin-bottom: 1rem;
  background-color: #131111;
  padding: 0.5rem 1rem;
  box-shadow: inset #ff4545 0px 0px 5px 0px;
  box-shadow: inset #000000 0px 0px 4px 0px;
  background-color: rgba(125, 125, 125, 0.5);
  font-weight: bold;

  & .amount {
    background-color:#454545;
    border-radius:0.5rem;
    padding: 0.3rem 0.5rem;
    font-weight: bold;
    font-size: 0.9rem;
    background-color: black;
  }

  & .canceled {
    background-color: red;
  }

  & .pending {
    background-color: orange;
  }

  & .approved {
    background-color: green;
  }
}
</style>